import 'angular';
import '../../../../../lib/assets/javascripts/devex/browser_url';
// SearchJS dependencies
import 'jquery';
import 'lodash';
import '../../../../../lib/assets/javascripts/devex/urls';
import '../../../../../lib/assets/javascripts/devex/search/sorting';
import '../../../../../lib/assets/javascripts/devex/search/filter';
import '../../../../../lib/assets/javascripts/devex/search/pagination';
import '../../../../../lib/assets/javascripts/devex/search/searchJS';

/**
 * Angular service to handle bookmarked_search_id URL parameter, its edition and
 * creation, uses BrowserUrl library, Singleton object. Built to be less
 * dependent on directive scopes
 */

angular
  .module('models.bookmarkedSearchService', [])
  .factory('bookmarkedSearchService', function () {
    var that = this;

    /**
     * Object where the active saved search (present in URL) is copied and stored.
     */
    that.active = {};

    /**
     * This boolean is used by container directive to trigger the first searchJs search. Turn it on
     * after all URL manipulations triggered by bookmarked_search_id param in incoming URL
     *
     */
    that.triggerSearchJs = false;

    /**
     * Register the bookmarked_search_id param in BrowserUrl JS library. To be
     * called on initialization of the Angular app.
     *
     * Getter method: set the ID of the active object as param value
     *
     * Setter: On page init, incoming param value will be saved in the active
     * object as ID.
     *
     * @returns {undefined}
     */
    that.startInit = function () {
      devex.urls.BrowserUrl.getInstance().addParam(
        {
          bookmarked_search_id: function () {
            if (!that.active) {
              return {};
            }
            return that.active.id;
          },
        },
        function (bookmarkedSearchId) {
          that.active = {
            ...that.active,
            id: bookmarkedSearchId,
          };
        }
      );

      // On init, if there is no bookmarked_search_id param in the incoming URL,
      // do not wait for the bookmarked searches to be loaded, before triggering
      // searchJs search
      if (!devex.urls.getParams().bookmarked_search_id) {
        that.triggerSearchJs = true;
      }
    };

    /**
     * On first page load and IF there is a `bookmarked_search_id` param in the URL,
     * this method will be called. It will compare the service's active object (at that time, it's
     * an object with a prop ID set in `#startInit`) with a list of bookmarked searches (first arg,
     * passed from a parent directive). If active object ID corresponds to an existing bookmark,
     * set this whole bookmark as `bookmarkedSearchService.active` and enable Edition mode. If not,
     * set `active` object to `{}`.
     * Reset URL and searchJs after that, before informing container directive that a
     * SearchJS search can be run now, through boolean `triggerSearchJs`
     *
     * @param {Array} bookmarkedSearches - Array of bookmarkedSearches
     * @param {Object} searchJs - Instance of SearchJs
     * @param {Array} whiteListedParams - Array of filters that will be forced, can be empty
     *
     * @returns {undefined}
     */
    that.finishInit = function (bookmarkedSearches, searchJs, whiteListedParams) {
      var incomingBookmarkedSearch = _.find(bookmarkedSearches, function (search) {
        return search.id === that.active.id;
      });

      if (incomingBookmarkedSearch) {
        that.active = angular.copy(
          that.forceWhitelistedParams(whiteListedParams, searchJs, incomingBookmarkedSearch)
        );
        that.alertSectionOptions.isBookmarkedSearchApplied = true;
        searchJs.loadParams(that.active.params);
        devex.urls.BrowserUrl.getInstance().updateUrl();
      } else {
        that.active = {};
      }
      that.triggerSearchJs = true;
    };

    /**
     * * On first load of the page, if there is an updated_since or a type filter
     * applied in the URL and if the bookmarked search id exists in the bookmarked
     * searches of the page, merge the incoming whitelisted filters to bookmarked
     * search filters before running searchJs search
     *
     * @param {Array} whitelistedParams - An array of whitelisted params
     * @param {Object} searchJs - Instance of SearchJs
     * @param {Object} incomingBookmarkedSearch - Incoming bookmarked search object
     * @returns {Object} The bookmarked search with correct params or null
     */
    that.forceWhitelistedParams = function (whitelistedParams, searchJs, incomingBookmarkedSearch) {
      whitelistedParams.forEach(function (filterName) {
        if (searchJs.filter[filterName].isActive()) {
          if (!incomingBookmarkedSearch.params.filter) {
            incomingBookmarkedSearch.params.filter = {};
          }
          incomingBookmarkedSearch.params.filter[filterName] = searchJs.filter[
            filterName
          ].getValue();
        }
      });
      return incomingBookmarkedSearch;
    };

    /**
     * DEPRECATED this method should be reserved for the Funding Search
     *
     * Set the active bookmarked search object filters in searchJs and trigger a
     * Browser URL update URL, that will trigger itself searchJs search if needed
     *
     * @param {Object} searchJs - Instance of searchJs
     *
     * @returns {undefined}
     */
    that.reloadSearchJs = function (searchJs) {
      if (that.active.id) {
        searchJs.loadParams(that.active.params);
      }
      devex.urls.BrowserUrl.getInstance().updateUrl();

      // By calling directly this paramChange event, we make sure the search bar filters are
      // correctly in phase with SearchJs values. We re-evaluate filter values and tie them to
      // SearchJs. Not search is run, this happened when calling updateUrl from BrowserUrl.
      searchJs.trigger('paramChange');
    };

    /**
     * This object is used to communicate between different directives/components. Those options are
     * used to show/hide dropdowns or sections.
     *
     * @type {Object} alertSectionOptions
     */
    that.alertSectionOptions = {
      isBookmarkedSearchApplied: false,
      isCreationExpanded: false,
      isContainerExpanded: false,
      isListExpanded: false,
      isEditionExpanded: false,
    };

    return that;
  });
